import instance from '@apis/instance';
import {
    GetGiftBoxParams,
    GiftBoxResponse, GiftBoxRow, GiftBoxType,
} from '@models/gift';
import { SliceResponse } from '@models/page';

class GiftBoxApi {
    static getGiftBoxes(giftBoxType: GiftBoxType, sorter: string): Promise<SliceResponse<GiftBoxRow>> {
        return instance.get('gift-box', { params: { giftBoxType, sorter } });
    }

    static getGiftBox(giftBoxId: string, params: GetGiftBoxParams): Promise<GiftBoxResponse> {
        return instance.get(`/gift-box/${giftBoxId}`, { params });
    }
}

export default GiftBoxApi;
